import campusApi from './modules/campusApi.js'
import serveApi from './modules/serveApi.js'
import permissionApi from './modules/permissionApi.js'
import roleApi from './modules/roleApi.js'
import userApi from './modules/userApi.js'
import matchApi from './modules/matchApi.js'
import communityApi from './modules/communityApi.js'
import newsApi from './modules/newsApi.js'
import activityApi from './modules/activityApi.js'
import courseApi from './modules/courseApi.js'
import baseApi from './modules/baseApi.js'

const api = {
  ...campusApi,
  ...permissionApi,
  ...roleApi,
  ...userApi,
  ...serveApi,
  ...matchApi,
  ...communityApi,
  ...newsApi,
  ...activityApi,
  ...courseApi,
  ...baseApi,
  LOGIN: 'user/login' //登录
}

export default api
